// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as CustomerFormCmp from "../CustomerFormCmp.bs.js";
import * as CustomerApiHandler from "../../state-machine/CustomerApiHandler.bs.js";
import * as CustomerInfoSidebarTabs from "./CustomerInfoSidebarTabs.bs.js";
import * as NotificationSettingsCmp from "./NotificationSettingsCmp.bs.js";
import * as ConsentStatusStateMachine from "../../state-machine/ConsentStatusStateMachine.bs.js";
import * as CustomerInfoSideBarHeader from "./CustomerInfoSideBarHeader.bs.js";

function CustomerInfoSidebar(Props) {
  var customer_data = Props.customer_data;
  var cashback_data = Props.cashback_data;
  var customer_id = Props.customer_id;
  var phone_number = Props.phone_number;
  var geo_region_items = Props.geo_region_items;
  var openSnackbar = Props.openSnackbar;
  var dispatch = Props.dispatch;
  var closeCustomerInfoSidebar = Props.closeCustomerInfoSidebar;
  var pageRefresh = Props.pageRefresh;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useState(function () {
        return /* BasicDetails */0;
      });
  var activeCustomerInfoTab = match$1[0];
  var match$2 = React.useState(function () {
        return false;
      });
  var setIsAllEditable = match$2[1];
  var isAllEditable = match$2[0];
  var match$3 = React.useState(function () {
        return false;
      });
  var setIsConsentUpdated = match$3[1];
  var isConsentUpdated = match$3[0];
  var match$4 = React.useReducer(ConsentStatusStateMachine.machine, /* Init */0);
  var consent_status_dispatch = match$4[1];
  var consent_status_state = match$4[0];
  var getCustomerConsents = function (consent_status_state) {
    if (typeof consent_status_state === "number") {
      return [];
    } else if (consent_status_state.TAG === /* Data */0) {
      return consent_status_state._0;
    } else {
      return [];
    }
  };
  var getTabs = function (consent_status_state) {
    if (typeof consent_status_state === "number" || !(consent_status_state.TAG === /* Data */0 && consent_status_state._0.length !== 0)) {
      return CustomerInfoSidebarTabs.tabsList;
    } else {
      return CustomerInfoSidebarTabs.consentTabsList;
    }
  };
  React.useEffect((function () {
          var match = process.env.INFRA_STACK;
          if (match === "uae") {
            CustomerApiHandler.FetchCustomerConsents.execute((function (data) {
                    return Curry._1(consent_status_dispatch, {
                                TAG: /* FetchCustomerConsentsSuccess */0,
                                _0: data
                              });
                  }), (function (error) {
                    return Curry._1(consent_status_dispatch, {
                                TAG: /* FetchCustomerConsentsFailure */1,
                                _0: error
                              });
                  }), customer_data.summary.uuid, country);
          }
          
        }), []);
  React.useEffect((function () {
          if (activeCustomerInfoTab) {
            Curry._1(setIsAllEditable, (function (param) {
                    return false;
                  }));
          } else {
            Curry._1(setIsConsentUpdated, (function (param) {
                    return false;
                  }));
          }
          
        }), [activeCustomerInfoTab]);
  return React.createElement("div", {
              className: "c-customer-info-sidebar"
            }, React.createElement(CustomerInfoSideBarHeader.make, {
                  tabs: getTabs(consent_status_state),
                  activeCustomerInfoTab: activeCustomerInfoTab,
                  changeCustomerInfoTab: match$1[1],
                  isConsentUpdated: isConsentUpdated,
                  isAllEditable: isAllEditable,
                  setIsAllEditable: setIsAllEditable,
                  closeCustomerInfoSidebar: closeCustomerInfoSidebar
                }), activeCustomerInfoTab ? React.createElement(NotificationSettingsCmp.make, {
                    uuid: customer_data.summary.uuid,
                    customer_consents: getCustomerConsents(consent_status_state),
                    isConsentUpdated: isConsentUpdated,
                    setIsConsentUpdated: setIsConsentUpdated,
                    openSnackbar: openSnackbar,
                    closeCustomerInfoSidebar: closeCustomerInfoSidebar
                  }) : React.createElement(CustomerFormCmp.make, {
                    customer_data: customer_data,
                    cashback_data: cashback_data,
                    customer_id: customer_id,
                    phone_number: phone_number,
                    geo_region_items: geo_region_items,
                    isAllEditable: isAllEditable,
                    dispatch: dispatch,
                    openSnackbar: openSnackbar,
                    pageRefresh: pageRefresh,
                    closeCustomerInfoSidebar: closeCustomerInfoSidebar
                  }));
}

var make = CustomerInfoSidebar;

export {
  make ,
  
}
/* react Not a pure module */
